export enum CandidateType {
    Full = 1,
    Skeleton = 2,
    SkeletonPending = 3,
    Pending = 4
}
